module.exports = __webpack_public_path__ + "img/Visa.c18ac218.svg";